import _extends from "babel-runtime/helpers/extends";
import _Object$values from "babel-runtime/core-js/object/values";
import _Object$keys from "babel-runtime/core-js/object/keys";
import React from "react";
import { wrapSelectors } from "@rosetta/redux-utils";
import { localizeStringFormatted } from "../service/lion-service";
import loggerConfig from "../config/logger-config";

var isObjectEmpty = function isObjectEmpty(obj) {
  return _Object$keys(obj).length === 0 && obj.constructor === Object;
};

var objectIsNullOrEmpty = function objectIsNullOrEmpty(val) {
  if (val === null) return true;
  return val === undefined;
};
var stringIsNullOrEmpty = function stringIsNullOrEmpty(val) {
  if (val === null) return true;
  if (val === undefined) return true;
  return val === "";
};
var propertyIsMissingOrEmpty = function propertyIsMissingOrEmpty(object, property) {
  if (stringIsNullOrEmpty(property)) return true;
  if (objectIsNullOrEmpty(object)) return true;
  if (!object.hasOwnProperty(property)) return true;
  return !!isObjectEmpty(object[property]);
};

var lionLogger = {
  info: function info(msg) {
    if (loggerConfig.showInfo) {
      console.info(msg);
    }
  },

  error: function error(msg) {
    if (loggerConfig.showError) {
      console.error(msg);
    }
  },

  debug: function debug(msg) {
    if (loggerConfig.showDebug) {
      console.info(msg);
    }
  },

  warn: function warn(msg) {
    if (loggerConfig.showWarn) {
      console.info(msg);
    }
  }
};

var findTranslation = function findTranslation(lionKey, resources, locale) {
  if (!lionKey) return null;

  if (!propertyIsMissingOrEmpty(resources[locale], "app")) {
    // check to see if the key exists in the app resources.
    if (resources[locale].app.hasOwnProperty(lionKey)) {
      lionLogger.info("Using resource for " + lionKey + " from app " + locale);
      return resources[locale].app[lionKey];
    }
  }
  if (!propertyIsMissingOrEmpty(resources[locale], "product")) {
    // check to see if the lionKey exists in the product resources.
    if (resources[locale].product.hasOwnProperty(lionKey)) {
      lionLogger.info("Using resource for " + lionKey + " from product " + locale);
      return resources[locale].product[lionKey];
    }
  }
};

var getLionTranslatedString = function getLionTranslatedString(state, key, replacements, altLocale, altFallback) {
  return getLionTranslatedStringWithFallback(state, key, undefined, replacements, altLocale, altFallback);
};

var getLionTranslatedStringWithFallback = function getLionTranslatedStringWithFallback(state, key, fallbackKey, replacements, altLocale, altFallback) {
  // if an alternate locale is supplied use over state value
  var primaryLocale = altLocale ? altLocale : state.locale;
  var fallbackLocale = altFallback ? altFallback : state.fallback;

  if (typeof key === "object") {
    // Special syntax for pluralization
    var values = _Object$values(replacements);
    if (values.length !== 1) {
      lionLogger.error("Can not use lionkey object syntax without exactly 1 replacement value");
      return "";
    }
    key = key[values[0]] || key.n;
  }

  if (stringIsNullOrEmpty(key)) {
    // If there is no key supplied, return error string.
    var noKeyError = "No key was supplied for localization.";
    lionLogger.error(noKeyError);
    return noKeyError;
  }

  // if the supplied locale doesn't exist in the resources block, return error string.
  if (propertyIsMissingOrEmpty(state.resources, primaryLocale) && propertyIsMissingOrEmpty(state.resources, fallbackLocale)) {
    // if neither app nor product resources are present, return error string.
    var noResourcesError = "No localizations have been loaded for " + primaryLocale + " or fallback " + fallbackLocale + " - localizing key " + key;
    lionLogger.error(noResourcesError);
    return key;
  }

  /* Order of fallback:
      1. Key in primary locale
      2. Fallback key in primary locale
      3. Key in fallback locale
      4. Fallback key in fallback locale
  */
  var translation = findTranslation(key, state.resources, primaryLocale) || findTranslation(fallbackKey, state.resources, primaryLocale) || findTranslation(key, state.resources, fallbackLocale) || findTranslation(fallbackKey, state.resources, fallbackLocale);

  var translatedString = localizeStringFormatted(translation, replacements);

  if (stringIsNullOrEmpty(translatedString)) {
    // return the translated string if present.
    lionLogger.error("String for " + key + " cannot be found in " + primaryLocale + " or in fallback " + fallbackLocale);
    return key;
  } else {
    return translatedString;
  }
};

var getLionAppResources = function getLionAppResources(state) {
  if (state.resources[state.locale].hasOwnProperty("app")) {
    return state.resources[state.locale].app;
  }
  return null;
};

var getLionProductResources = function getLionProductResources(state) {
  if (state.resources[state.locale].hasOwnProperty("product")) {
    return state.resources[state.locale].product;
  }
  return null;
};

var lionSelectors = {
  getLionLanguage: function getLionLanguage(state) {
    return state.locale;
  },
  getLionFallbackLanguage: function getLionFallbackLanguage(state) {
    return state.fallback;
  },
  getLionAppResources: getLionAppResources,
  getLionAppResourcesLoaded: function getLionAppResourcesLoaded(state) {
    return state.appResourcesLoaded;
  },
  getLionProductResources: getLionProductResources,
  getLionProductResourcesLoaded: function getLionProductResourcesLoaded(state) {
    return state.productResourcesLoaded;
  },
  getLionTranslatedString: getLionTranslatedString,
  getLionTranslatedStringWithFallback: getLionTranslatedStringWithFallback
};

var lionStateWrapper = function lionStateWrapper(selector) {
  return function (state) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return selector.apply(undefined, [state.lion].concat(args));
  };
};

var selectors = _extends({}, wrapSelectors(lionStateWrapper, lionSelectors));

export default selectors;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@rosetta/react-lion/es/selectors/lion-selectors.js
// module id = 240
// module chunks = 0